import React, { useEffect, useMemo, useState } from "react";
import Navbar from "../../Components/Navbar";
import Overview from "../../Components/Overview";
import TransactionTable from "../../Components/TransactionTable";
import RecentTransaction from "../../Components/RecentTransaction";
import ProfileSetup from "../../Components/ProfileSetup";
import PortfolioAllocation from "../../Components/PortfolioAllocation";
import { FiChevronLeft, FiChevronRight, FiMoreVertical } from "react-icons/fi";
import Card from "../../Components/Card";
import ngnInvest from "../../Assets/Images/ngn-invest.png";
import usdInvest from "../../Assets/Images/usd-invest.png";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getOpportunities } from "../../store/actions/opportunities/getopportunities";
import { getPayout } from "../../store/actions/payouts/getPayout";
import { autoFetchPayout } from "../../store/actions/payouts/autoFetchPayout";
import { autoGetProfile } from "../../store/actions/profile/autoGetProfile ";
import emptyState from "../../Assets/Images/emptyState.png";
import Loader from "../../Components/Utils/Loader";
import { allDashboard } from "../../store/actions/dashboard/allDashboard";
import UpdatePin from "../../Components/UpdatePin";
import DashboardPortfolioOverview from "../../Components/DashboardPortfolioOverview";
import FilterButton from "../../Components/Buttons/FilterButton";
import FollowAndTrack from "../../Components/FollowAndTrack";
import PortfolioDateModal from "../../Components/PortfolioDateModal";
import UpdateIdOldUsers from "../../Components/UpdateIdOldUsers";
import { setActiveTab } from "../../store/reducers/dashboardSlice";
import InProgress from "../../Components/InProgress";
import CampaignCard from "../../Components/CampaignCard";
import { getBalance } from "../../store/actions/dashboard/manageFunds";
import PinConfirmation from "../../Components/PinConfirmation";
import AmountModal from "../../Components/AmountModal";
import { submitInvestment } from "../../store/actions/investment/submitinvestment";
import InvesmentCycleTimelineModal from "../../Components/InvesmentCycleTimelineModal";
import { submitRealEstateInvestment } from "../../store/actions/realEstate/submitRealEstateInvestment";
import { getOpenInvestments } from "../../store/actions/opportunities/getOpenInvestments";
import Switcher from "../../Components/Switcher";
import mixpanel from "mixpanel-browser";
import { getUpcomingInvestments } from "../../store/actions/opportunities/getUpcomingInvestments";
import HWSBar from "../../Components/HWSBar";

const DashboardHome = () => {
  const [_currency, _setCurrency] = useState("NGR");
  const [_upcomingcurrency, _setUpcomingCurrency] = useState("NGR");
  const [loadingInvestments, setLoadingInvestments] = useState(true);
  const [activeInvestments, setActiveInvestments] = useState([]);
  const [upcominbInvestments, setUpcominbInvestments] = useState([]);
  const [showModal, setShowModal] = useState(null);
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  const [timelines, showTimelines] = useState(null);
  const [showPinModal, setShowPinModal] = useState(false);
  const [showOldUsersModal, setShowOldUsersModal] = useState(false);
  const [investmentStatementModalOpen, setInvestmentStatementModalOpen] =
    useState(false);

  const { activeTab } = useSelector((state) => state?.dashboard);
  const [showConfirmationModal, setShowConfirmationModal] = useState(null);

  const { user, profile } = useSelector((state) => state.onboarding);
  const navigate = useNavigate();

  const { userBanks } = useSelector((state) => state?.bank) || [];

  const dispatch = useDispatch();
  // const currency = "NGR";

  const [currency, setCurrency] = useState("Naira");

  useEffect(() => {
    dispatch(getOpportunities({ currency }));
    dispatch(getPayout(currency === "Naira" ? "NGR" : "USD"));

    const clean = setInterval(() => {
      dispatch(autoFetchPayout(currency));
      dispatch(autoGetProfile());
    }, 60000);
    return () => {
      clearInterval(clean);
    };
  }, [currency]);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    dispatch(
      allDashboard(() => {
        setLoading(false);
      })
    );
  }, []);

  useEffect(() => {
    setShowOldUsersModal(true);
  }, []);

  const verificationStatus = localStorage.getItem("verificationStatus");

  const handleConfirm = ({
    otp,
    adminFee,
    investment_product_id,
    amount,
    id,
    name,
    opportunity,
    investment,
    campaign,
  }) => {
    mixpanel.track("WEB-Submited Investment from the Dashboard", {
      type: "Live Campaigns",
    });

    if (
      investment?.investmentCategory?.name?.toLowerCase() == "sme financing" ||
      investment?.investmentCategory?.name?.toLowerCase() ==
        "none interest commercial paper (nicp)"
    ) {
      const total = adminFee + +amount;
      const data = {
        data: {
          amount: Number(amount),
          investment_product_id: Number(investment?.investment_id),
          cycle_id: Number(id),
          payment_type: "transfer",
          transaction_pin: otp,
        },
        name: name,
        failed: () => {
          setShowConfirmationModal(null);
          setShowModal(showConfirmationModal?.showModalData);
        },
        cb: (response) => {
          setShowConfirmationModal(null);
          navigate(`/investment-summary/${id}`, {
            state: {
              adminFee,
              amount,
              id,
              name,
              investment,
              opportunity,
              response,
              campaign,
              portfolioID: response?.portfolio_id,
            },
          });
        },
      };

      dispatch(submitInvestment(data));
    } else {
      const total = adminFee + +amount;
      const data = {
        data: {
          unit: Number(amount),

          property_product_id: Number(investment?.id),

          payment_type: "transfer",
          transaction_pin: otp,
        },

        failed: () => {
          setShowConfirmationModal(null);
          setShowModal(showConfirmationModal?.showModalData);
        },
        cb: (response) => {
          setShowConfirmationModal(null);
          navigate(`/investment/realestate/summary/${id}`, {
            state: {
              adminFee,
              amount,
              investment,
              response,
              portfolioID: response?.portfolio_id,
            },
          });
        },
      };

      dispatch(submitRealEstateInvestment(data));
    }
  };

  useEffect(() => {
    setLoadingInvestments(true);
    dispatch(
      getOpenInvestments({
        currency: _currency,
        cb: (res) => {
          setLoadingInvestments(false);

          setActiveInvestments(res);
        },
        failed: () => {
          setLoadingInvestments(false);
        },
      })
    );
  }, [_currency]);
  useEffect(() => {
    setLoadingInvestments(true);
    dispatch(
      getUpcomingInvestments({
        currency: _upcomingcurrency,
        cb: (res) => {
          setLoadingInvestments(false);

          setUpcominbInvestments(res);
        },
        failed: () => {
          setLoadingInvestments(false);
        },
      })
    );
  }, [_upcomingcurrency]);

  const [lifeCurrentPage, setLifeCurrentPage] = useState(1);
  const [upcomingCurrentPage, setUpcomingLifeCurrentPage] = useState(1);

  const isPrevLifeValid = lifeCurrentPage > 1;
  const isNextLifeValid = useMemo(
    () => activeInvestments.length > lifeCurrentPage * 2,
    [activeInvestments, lifeCurrentPage]
  );
  const isPrevUpcomingValid = upcomingCurrentPage > 1;
  const isNextUpcomingValid = useMemo(
    () => upcominbInvestments.length > upcomingCurrentPage * 2,
    [upcominbInvestments, upcomingCurrentPage]
  );

  return (
    <>
      <div className="flex relative flex-col bg-[#F9FAFA] gap-6 pt-3 pb-3 items-center min-h-screen">
        <Navbar type={3} />
        {/* <HWSBar /> */}

        <div className="w-[95%] flex-col lg:flex-row flex-1 h-full border-[#F2F2F2] border-[1.1px] drop-shadow-custom rounded-[12px] gap-5 p-6 md:p-10 bg-[#FFF] max-w-[1664px] flex">
          {loading && !profile && userBanks?.length < 1 ? (
            <Loader />
          ) : (
            <>
              <div className="flex flex-col flex-1">
                <div className="w-min mt-3 border-[#F0F0F5] drop-shadow-custom mb-4 p-2 h-[49px] border-[1px] rounded-[41px] flex justify-center items-center">
                  <FilterButton
                    items={[
                      { label: "Overview", value: "overview" },
                      { label: "Portfolio", value: "portfolio" },
                    ]}
                    active={activeTab}
                    setActive={(value) => {
                      dispatch(setActiveTab(value));
                    }}
                  />
                </div>
                <h2 className="text-[54px] font-[400] leading-[59.4px] tracking-[-3.1%] mb-[20px] max-w-[380px]">
                  {userBanks?.length > 0 ||
                  profile?.nok_email ||
                  profile?.gender
                    ? "Welcome back"
                    : "Get started"}
                  , {user?.name?.split(" ")[0]}
                </h2>
                <div className="mt-3">
                  <h4 className="font-[500] text-[#131E3D] mb-[16px] text-base leading-[17.6px] tracking-[-1%]">
                    {activeTab === "overview"
                      ? "Overview"
                      : "Portfolio Allocation"}
                  </h4>
                  {activeTab === "overview" ? (
                    <DashboardPortfolioOverview
                      currency={currency}
                      setCurrency={setCurrency}
                    />
                  ) : (
                    <PortfolioAllocation />

                    // <Overview currency={currency} setCurrency={setCurrency} />
                  )}
                </div>
                <div>
                  {activeTab === "overview" ? (
                    <>
                      <div className="max-w-[698px] flex items-center justify-between mb-5 mt-10 pr-1 ">
                        <h4 className="font-[500] text-[#131E3D] text-base leading-[17.6px] tracking-[-1%]">
                          Recent Transactions
                        </h4>
                        {/* <FiMoreVertical
                          className="cursor-pointer"
                          size={20}
                          color={"#131E3D"}
                        /> */}
                      </div>
                      <TransactionTable currency={currency} />
                    </>
                  ) : (
                    <div
                      onClick={() => {
                        navigate("/investment-statement");
                      }}
                      className="flex items-center gap-2 py-3 mt-7 cursor-pointer"
                    >
                      <img
                        src={require("../../Assets/Images/download-statement.png")}
                        className="w-5 h-5"
                      />
                      <h3 className="text-[13.33px] font-[500] text-[#6935D3]">
                        DOWNLOAD YOUR INVESTMENT STATEMENT
                      </h3>
                    </div>
                  )}
                </div>
              </div>
              <div className="flex flex-col flex-1">
                {user?.hasSetPin &&
                profile?.nok_email &&
                profile?.gender &&
                userBanks?.length > 0 ? (
                  activeTab === "overview" ? (
                    <div className="sm:mt-10"></div>
                  ) : (
                    <div className="max-w-[731px] flex items-center justify-between mb-5 sm:mt-10 mr-1 ">
                      <h4 className="font-[500] text-[#131E3D] text-base leading-[17.6px] tracking-[-1%]">
                        Explore Opportunities
                      </h4>
                    </div>
                  )
                ) : (
                  <div>
                    <div className="max-w-[731px] flex items-center justify-between mb-5 mt-10 mr-1 ">
                      <h4 className="font-[500] text-[#131E3D] text-base leading-[17.6px] tracking-[-1%]">
                        Complete your profile{" "}
                        <span className="font-[500] text-[#9C9C9E] text-base leading-[17.6px] tracking-[-1%]">
                          in ~5 minutes
                        </span>
                      </h4>
                      <FiMoreVertical
                        className="contain-paint cursor-pointer"
                        size={20}
                        color={"#131E3D"}
                      />
                    </div>
                    <ProfileSetup setShowPinModal={setShowPinModal} />
                  </div>
                )}
                {activeTab === "overview" ? (
                  <div className="mx-auto ">
                    <>
                      <div className="max-w-[512px] sm:w-[512px] flex items-center justify-between mb-5  mr-1 ">
                        <h4 className="font-[500] text-[#131E3D] text-base leading-[17.6px] tracking-[-1%]">
                          Explore Live Campaigns
                        </h4>

                        <div className="w-min mt-3 border-[#F0F0F5] drop-shadow-custom mb-4 p-2 h-[49px] border-[1px] rounded-[41px] flex justify-center items-center">
                          <FilterButton
                            items={[
                              { label: "Naira", value: "NGR" },
                              { label: "USD", value: "USD" },
                            ]}
                            disabled={loadingInvestments}
                            active={_currency}
                            setActive={_setCurrency}
                          />
                        </div>
                      </div>

                      {loadingInvestments ? (
                        <div className="max-w-[512px] h-[400px] flex justify-center items-center">
                          <Loader />
                        </div>
                      ) : activeInvestments?.length > 0 ? (
                        <>
                          {activeInvestments
                            ?.slice(
                              (lifeCurrentPage - 1) * 2,
                              lifeCurrentPage * 2
                            )
                            .map((item, ind) => {
                              return (
                                <CampaignCard
                                  launchDate={item?.launch_date}
                                  investment_type={item?.investment_type}
                                  roi_range={item?.roi_range}
                                  investmentCategory={item?.investmentCategory}
                                  type={"small"}
                                  key={ind}
                                  status={item?.status}
                                  showTimelines={() => {
                                    mixpanel.track(
                                      "WEB-Viewed Timeline from the Dashboard",
                                      {
                                        type: "Live Campaigns",
                                      }
                                    );

                                    showTimelines({
                                      cycle: item,
                                    });
                                  }}
                                  investors={item?.investors}
                                  title={item?.name}
                                  tenure={
                                    item?.investmentCategory?.name?.toLowerCase() ===
                                      "sme financing" ||
                                    item?.investmentCategory?.name?.toLowerCase() ===
                                      "none interest commercial paper (nicp)"
                                      ? item?.duration
                                      : item?.property_appreciation
                                  }
                                  nReturn={Number(
                                    item?.investmentCategory?.name?.toLowerCase() ===
                                      "sme financing" ||
                                      item?.investmentCategory?.name?.toLowerCase() ===
                                        "none interest commercial paper (nicp)"
                                      ? item?.roi
                                      : item?.annual_roi
                                  )}
                                  onClick={() => {
                                    mixpanel.track(
                                      "WEB-Clicked Invest Now Button from the Dashboard",
                                      {
                                        type: "Live Campaigns",
                                      }
                                    );
                                    dispatch(
                                      getBalance({
                                        cb: () => {},
                                      })
                                    );
                                    setShowModal({
                                      cycle: item,
                                    });
                                  }}
                                  payoutType={
                                    item?.repayment_type === "PMCE" ||
                                    item?.payout_type === "PMCE"
                                      ? "Profit Monthly, Capital at the end"
                                      : item?.repayment_type === "PACM" ||
                                        item?.payout_type === "PACM"
                                      ? "Profit and Capital Monthly"
                                      : item?.repayment_type === "PACE" ||
                                        item?.payout_type === "PACE"
                                      ? "Profit and Capital at the end"
                                      : item?.repayment_type ||
                                        item?.payout_type
                                  }
                                  investment_memo={
                                    item?.investmentCategory?.name?.toLowerCase() ===
                                      "sme financing" ||
                                    item?.investmentCategory?.name?.toLowerCase() ===
                                      "none interest commercial paper (nicp)"
                                      ? item?.investment_memo
                                      : item?.properties_documents
                                      ? item?.properties_documents[0]
                                      : null
                                  }
                                  dueDate={
                                    item?.investmentCategory?.name?.toLowerCase() ===
                                      "sme financing" ||
                                    item?.investmentCategory?.name?.toLowerCase() ===
                                      "none interest commercial paper (nicp)"
                                      ? item?.due_date
                                      : item?.campaign_due_date
                                  }
                                  invested={
                                    item?.investmentCategory?.name?.toLowerCase() ===
                                      "sme financing" ||
                                    item?.investmentCategory?.name?.toLowerCase() ===
                                      "none interest commercial paper (nicp)"
                                      ? item?.investors?.reduce((acc, curr) => {
                                          return acc + +curr?.amount;
                                        }, 0) || 0
                                      : item?.total_amount_invested
                                  }
                                  totalAmount={Number(
                                    item?.investmentCategory?.name?.toLowerCase() ===
                                      "sme financing" ||
                                      item?.investmentCategory?.name?.toLowerCase() ===
                                        "none interest commercial paper (nicp)"
                                      ? item?.amount
                                      : item?.total_units *
                                          item?.amount_per_unit
                                  )}
                                  currency={
                                    item?.currency === "USD" ? "$" : "₦"
                                  }
                                />
                              );
                            })}

                          {activeInvestments?.length > 2 ? (
                            <div className="max-w-[512px] flex items-center gap-5 pt-5 pb-2">
                              {isPrevLifeValid ? (
                                <div
                                  onClick={
                                    isPrevLifeValid
                                      ? () => {
                                          setLifeCurrentPage(
                                            (prev) => prev - 1
                                          );
                                        }
                                      : null
                                  }
                                  className="flex cursor-pointer items-center gap-[0px]"
                                >
                                  <FiChevronLeft
                                    size={"14px"}
                                    color={
                                      isPrevLifeValid ? "#9C9C9E" : "#131E3D"
                                    }
                                    className="mt-[1px]"
                                  />
                                  <h4
                                    className={` font-[400] text-[13px]  tracking-[-0.4%] ${
                                      isPrevLifeValid
                                        ? "text-[#9C9C9E}"
                                        : "text-[#131E3D]"
                                    }`}
                                  >
                                    Previous
                                  </h4>
                                </div>
                              ) : (
                                <></>
                              )}
                              {isNextLifeValid ? (
                                <div
                                  onClick={
                                    isNextLifeValid
                                      ? () => {
                                          setLifeCurrentPage(
                                            (prev) => prev + 1
                                          );
                                        }
                                      : () => {}
                                  }
                                  className="flex cursor-pointer items-center gap-[0px]"
                                >
                                  <h4
                                    className={`outline-none font-[400] text-[13px] tracking-[-0.4%] ${
                                      isNextLifeValid
                                        ? "text-[#9C9C9E}"
                                        : "text-[#131E3D]"
                                    }`}
                                  >
                                    Next
                                  </h4>
                                  <FiChevronRight
                                    size={"14px"}
                                    color={
                                      isNextLifeValid ? "#9C9C9E" : "#131E3D"
                                    }
                                    className="mt-[1px]"
                                  />
                                </div>
                              ) : (
                                <></>
                              )}
                            </div>
                          ) : (
                            <></>
                          )}
                        </>
                      ) : (
                        <div className="w-full flex-col h-[500px] flex justify-center items-center">
                          <img
                            src={emptyState}
                            alt="Empty"
                            className=" mb-[5px] w-[76px] h-[76px] "
                          />
                          <div className=" mb-[5px] p-2 text-[16px] font-[400] text-[#9C9C9E] ">
                            No Live Campaigns
                          </div>
                        </div>
                      )}
                    </>
                    <>
                      <div className="max-w-[512px] sm:w-[512px] flex items-center justify-between mb-5  mr-1 ">
                        <h4 className="font-[500] text-[#131E3D] text-base leading-[17.6px] tracking-[-1%]">
                          Upcoming Campaigns
                        </h4>

                        <div className="w-min mt-3 border-[#F0F0F5] drop-shadow-custom mb-4 p-2 h-[49px] border-[1px] rounded-[41px] flex justify-center items-center">
                          <FilterButton
                            items={[
                              { label: "Naira", value: "NGR" },
                              { label: "USD", value: "USD" },
                            ]}
                            disabled={loadingInvestments}
                            active={_upcomingcurrency}
                            setActive={_setUpcomingCurrency}
                          />
                        </div>
                      </div>

                      {loadingInvestments ? (
                        <div className="max-w-[512px] h-[400px] flex justify-center items-center">
                          <Loader />
                        </div>
                      ) : upcominbInvestments?.length > 0 ? (
                        <>
                          {upcominbInvestments
                            ?.slice(
                              (upcomingCurrentPage - 1) * 2,
                              upcomingCurrentPage * 2
                            )
                            .map((item, ind) => {
                              return (
                                <CampaignCard
                                  launchDate={item?.launch_date}
                                  investment_type={item?.investment_type}
                                  roi_range={item?.roi_range}
                                  investmentCategory={item?.investmentCategory}
                                  type={"small"}
                                  key={ind}
                                  status={item?.status}
                                  showTimelines={() => {
                                    mixpanel.track(
                                      "WEB-Viewed Timeline from the Dashboard",
                                      {
                                        type: "Live Campaigns",
                                      }
                                    );

                                    showTimelines({
                                      cycle: item,
                                    });
                                  }}
                                  investors={item?.investors}
                                  title={item?.name}
                                  tenure={item?.duration}
                                  nReturn={Number(item?.roi)}
                                  onClick={() => {
                                    mixpanel.track(
                                      "WEB-Clicked Invest Now Button from the Dashboard",
                                      {
                                        type: "Live Campaigns",
                                      }
                                    );
                                    dispatch(
                                      getBalance({
                                        cb: () => {},
                                      })
                                    );
                                    setShowModal({
                                      cycle: item,
                                    });
                                  }}
                                  payoutType={
                                    item?.repayment_type === "PMCE" ||
                                    item?.payout_type === "PMCE"
                                      ? "Profit Monthly, Capital at the end"
                                      : item?.repayment_type === "PACM" ||
                                        item?.payout_type === "PACM"
                                      ? "Profit and Capital Monthly"
                                      : item?.repayment_type === "PACE" ||
                                        item?.payout_type === "PACE"
                                      ? "Profit and Capital at the end"
                                      : item?.repayment_type ||
                                        item?.payout_type
                                  }
                                  investment_memo={item?.investment_memo}
                                  dueDate={item?.due_date}
                                  invested={
                                    item?.investors?.reduce((acc, curr) => {
                                      return acc + +curr?.amount;
                                    }, 0) || 0
                                  }
                                  totalAmount={Number(item?.amount)}
                                  currency={
                                    item?.currency === "USD" ? "$" : "₦"
                                  }
                                />
                              );
                            })}

                          {upcominbInvestments?.length > 2 ? (
                            <div className="max-w-[512px] flex items-center gap-5 pt-5 pb-2">
                              {isPrevUpcomingValid ? (
                                <div
                                  onClick={
                                    isPrevUpcomingValid
                                      ? () => {
                                          setUpcomingLifeCurrentPage(
                                            (prev) => prev - 1
                                          );
                                        }
                                      : null
                                  }
                                  className="flex cursor-pointer items-center gap-[0px]"
                                >
                                  <FiChevronLeft
                                    size={"14px"}
                                    color={
                                      isPrevUpcomingValid
                                        ? "#9C9C9E"
                                        : "#131E3D"
                                    }
                                    className="mt-[1px]"
                                  />
                                  <h4
                                    className={` font-[400] text-[13px]  tracking-[-0.4%] ${
                                      isPrevUpcomingValid
                                        ? "text-[#9C9C9E}"
                                        : "text-[#131E3D]"
                                    }`}
                                  >
                                    Previous
                                  </h4>
                                </div>
                              ) : (
                                <></>
                              )}
                              {isNextUpcomingValid ? (
                                <div
                                  onClick={
                                    isNextUpcomingValid
                                      ? () => {
                                          setUpcomingLifeCurrentPage(
                                            (prev) => prev + 1
                                          );
                                        }
                                      : () => {}
                                  }
                                  className="flex cursor-pointer items-center gap-[0px]"
                                >
                                  <h4
                                    className={`outline-none font-[400] text-[13px] tracking-[-0.4%] ${
                                      isNextUpcomingValid
                                        ? "text-[#9C9C9E}"
                                        : "text-[#131E3D]"
                                    }`}
                                  >
                                    Next
                                  </h4>
                                  <FiChevronRight
                                    size={"14px"}
                                    color={
                                      isNextUpcomingValid
                                        ? "#9C9C9E"
                                        : "#131E3D"
                                    }
                                    className="mt-[1px]"
                                  />
                                </div>
                              ) : (
                                <></>
                              )}
                            </div>
                          ) : (
                            <></>
                          )}
                        </>
                      ) : (
                        <div className="w-full flex-col h-[500px] flex justify-center items-center">
                          <img
                            src={emptyState}
                            alt="Empty"
                            className=" mb-[5px] w-[76px] h-[76px] "
                          />
                          <div className=" mb-[5px] p-2 text-[16px] font-[400] text-[#9C9C9E] ">
                            No Upcoming Campaigns
                          </div>
                        </div>
                      )}
                    </>
                  </div>
                ) : (
                  <div className="gap-6 flex-wrap flex">
                    <Card
                      onClick={() => {
                        navigate(`/investment?currency=NGR`);
                      }}
                      className=" transition duration-[800ms] ease-in-out hover:scale-[102%]  w-full sm:w-[282px]  hover:bg-customPurple/90 "
                      type={2}
                      background="bg-customPurple"
                      text="Invest in Naira Assets"
                      imageSrc={ngnInvest}
                    />
                    <Card
                      onClick={() => {
                        navigate(`/investment?currency=USD`);
                      }}
                      type={2}
                      className=" transition duration-[800ms] ease-in-out hover:scale-[102%]  w-full sm:w-[282px]    hover:bg-[#192851]/80  "
                      background="bg-[#192851]"
                      text="Invest in USD Assets"
                      imageSrc={usdInvest}
                    />
                  </div>
                )}

                {/* {activeTab === "overview" ? <FollowAndTrack /> : <Porfolio />} */}
                {activeTab === "overview" ? <></> : <FollowAndTrack />}
              </div>
            </>
          )}
        </div>
      </div>
      {verificationStatus === "Pending-Notification" ? (
        <div className=" top-0 left-0 w-screen h-screen z-50 flex justify-center items-center fixed bg-[rgba(19,30,61,0.4)]">
          <InProgress
            subText={"Your ID is currently being reviewed"}
            buttonTitle="Ok"
            text={"Undergoing Review"}
            handleClose={() => {
              localStorage.setItem("verificationStatus", "Pending");
            }}
            next={() => {
              localStorage.setItem("verificationStatus", "Pending");
            }}
          />
        </div>
      ) : (
        <></>
      )}
      {(profile?.BVN || user?.bvn_verified) &&
      showOldUsersModal &&
      !profile?.id_verified &&
      verificationStatus !== "Pending-Notification" &&
      verificationStatus !== "No-Response" &&
      verificationStatus !== "Pending" ? (
        <div className="top-0 left-0 w-screen h-screen z-50 flex justify-center items-center fixed bg-[rgba(19,30,61,0.4)]">
          <UpdateIdOldUsers
            user={user}
            profile={profile}
            small
            handleClose={() => {
              setShowOldUsersModal(false);
            }}
          />
        </div>
      ) : null}
      {showPinModal ? (
        <div className="top-0 left-0 w-screen h-screen z-50 flex justify-center items-center fixed bg-[rgba(19,30,61,0.4)]">
          <UpdatePin
            small
            handleClose={() => {
              setShowPinModal(false);
            }}
            next={(value) => {
              setShowConfirmationModal(value);
              setShowPinModal(false);
            }}
          />
        </div>
      ) : null}

      {showModal ? (
        <div className=" top-0 left-0 w-screen h-screen z-50 flex justify-center items-center fixed bg-[rgba(19,30,61,0.4)]">
          <AmountModal
            type={
              showModal?.cycle?.investmentCategory?.name?.toLowerCase() ===
                "sme financing" ||
              showModal?.cycle?.investmentCategory?.name?.toLowerCase() ===
                "none interest commercial paper (nicp)"
                ? null
                : showModal?.cycle?.investment_category?.name == "Real Estate"
                ? "REAL_ESTATE"
                : "REAL_ESTATE"
            }
            values={showModal?.cycle}
            campaign={showModal?.campaign}
            admin_fee={
              showModal?.cycle?.investmentCategory?.name?.toLowerCase() ===
                "sme financing" ||
              showModal?.cycle?.investmentCategory?.name?.toLowerCase() ===
                "none interest commercial paper (nicp)"
                ? showModal?.cycle?.regular_admin_fee
                : showModal?.cycle?.admin_fee
            }
            handleClose={() => setShowModal(false)}
            next={(value) => {
              setShowConfirmationModal({ value, showModalData: showModal });
              setShowModal(false);
            }}
          />
        </div>
      ) : (
        <></>
      )}
      {showConfirmationModal ? (
        <div className=" top-0 left-0 w-screen h-screen z-50 flex justify-center items-center fixed bg-[rgba(19,30,61,0.4)]">
          <PinConfirmation
            handleClose={() => {
              setShowConfirmationModal(null);
            }}
            back={() => {
              setShowConfirmationModal(null);
              setShowModal(showConfirmationModal?.showModalData);
            }}
            handleSubmit={(otp) => {
              handleConfirm({
                ...showConfirmationModal?.value,
                otp,
                // opportunity,
                // investment_product_id: opportunity?.id,
              });
            }}
            buttonTitle={"Submit Investment"}
            subTitle={"Confirm your Halvest PIN to Invest"}
          />
        </div>
      ) : (
        <></>
      )}

      {timelines ? (
        <div className=" top-0 left-0 w-screen h-screen  z-50 flex justify-center items-center fixed bg-[rgba(19,30,61,0.4)]">
          <InvesmentCycleTimelineModal
            type={
              timelines?.cycle?.investmentCategory?.name?.toLowerCase() ===
                "sme financing" ||
              timelines?.investment?.investmentCategory?.name?.toLowerCase() ===
                "sme financing" ||
              timelines?.cycle?.investmentCategory?.name?.toLowerCase() ===
                "none interest commercial paper (nicp)"
                ? ""
                : timelines?.investment?.investmentCategory?.name?.toLowerCase() ===
                  "real estate"
                ? "REAL-ESTATE"
                : "REAL-ESTATE"
            }
            investment={timelines?.investment || timelines?.cycle}
            investmentId={
              timelines?.investment?.id ||
              timelines?.cycle?.investment_id ||
              timelines?.cycle?.id
            }
            close={() => showTimelines(false)}
          />
        </div>
      ) : (
        <></>
      )}
      {investmentStatementModalOpen && (
        <PortfolioDateModal
          defaultCurrency={currency}
          onClose={() => setInvestmentStatementModalOpen(false)}
        />
      )}
    </>
  );
};

export default DashboardHome;
